import { useEffect, useState } from 'react'
import { Droppable } from 'react-beautiful-dnd'

const StrictModeDroppable = ({ children, ...props }) => {
  const [canRender, setCanRender] = useState(false)

  useEffect(() => {
    const animation = requestAnimationFrame(() => setCanRender(true))

    return () => {
      cancelAnimationFrame(animation)
      setCanRender(false)
    }
  }, [])

  if (!canRender) return null

  return <Droppable {...props}>{children}</Droppable>
}

export default StrictModeDroppable
